import { AspectIndustry, AspectOccupation, AspectProduct } from '@lib.core/entities/indicator/indicator';
import { AspectContext } from '@lib.core/entities/indicator/indicator-context';
import { LocationDTO, newLocationEntityFromDto } from '@lib.resources/location/dtos/location';

export class AspectContextDTO {
  location?: LocationDTO;
  industry?: AspectIndustry;
  occupation?: AspectOccupation;
  product?: AspectProduct;

  static toAspectContext(aspectContextDTO: AspectContextDTO): AspectContext {
    const { location, industry, occupation, product } = aspectContextDTO;
    return new AspectContext(location ? newLocationEntityFromDto(location) : undefined, industry, occupation, product);
  }
}
